import React from "react"
import "./homepage.css"
import 'bootstrap/dist/css/bootstrap.min.css';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Fabric from "./fabric";


const Homepage = ({setLoginUser}) => {
    return (
    <>
    <div className="homepage">
    <Navbar bg="light" expand="lg">
      <Container fluid>
        <Navbar.Brand href="#">HELLO PAINTER</Navbar.Brand>
        <Navbar.Toggle aria-controls="navbarScroll" />
        <Navbar.Collapse id="navbarScroll">
          <Nav
            className="me-auto my-2 my-lg-0"
            style={{ maxHeight: '100px' }}
            navbarScroll
          >
          </Nav>
          <Form className="d-flex">
            <Button variant="primary" onClick={() => setLoginUser({})}>LogOut</Button>
          </Form>
        </Navbar.Collapse>
      </Container>
    </Navbar>
    </div>
    <div className="area">
    <Fabric/>
    </div>
    </>

    )
}

export default Homepage
